import {
  all, takeEvery, takeLatest, takeLeading, fork, take,
} from 'redux-saga/effects';

/**
 * Auth
 */
import { Types as AuthTypes } from '../ducks/auth';
import {
  login,
  forgotPasswordSendEmail,
  forgotPasswordCheckToken,
  forgotPasswordUpdatePassword,
  updateTriiderUser,
  getCompanies,
  changeCompanyUser,
} from './auth';

/**
 * Local
 */
import { Types as LocalsTypes } from '../ducks/locals';
import {
  getLocals, includeLocal, editLocal, deleteLocal,
} from './locals';

/**
 * Task
 */
import { Types as TaskTypes } from '../ducks/task';
import {
  getTasks,
  getTasksFilters,
  getTaskDetail,
  hireTask,
  cancelQuoteTask,
  cancelHiredTask,
  ratingTaskProfessionalRequest,
  authorizeTaskRequest,
  scheduling,
  getCancelTaskOptions,
  addPhotosToTask,
  removePhotosFromTask,
  getReportProblemReasons,
  reportProblem,
  getReportProblems,
  paymentInfo,
  getTaskByStatus,
  getTabsStatus,
  setTaskIsNeedVisit,
  setTaskVisit,
  getComments,
  includeComment,
  setOperatorTask,
  generateCheckoutLinkSaga,
  includeLabelTask,
  deleteLabelTask,
} from './task';

/**
 * Pro
 */
import { Types as ProTypes } from '../ducks/pro';
import { getProProfile, getProPortfolio } from './pro';

/**
 * Servie Form
 */
import { Types as FormTypes } from '../ducks/serviceForm';
import { finishForm } from './serviceForm';

/**
 * Chat
 */
import { Types as ChatTypes } from '../ducks/chat';
import {
  initChat, sendMessage, startTyping, stopTyping, readMessages,
} from './chat';

/**
 * companyResponsibilities
 */
import { Types as CompanyRespTypes } from '../ducks/companyResponsibility';
import { getResponsibilities, setResponsibilities } from './companyResponsibility';

/**
 * Dashboard
 */
import { Types as DashTypes } from '../ducks/dash';
import { getDashsInfo, getInvoicesDash, getPaymentTicketsDash } from './dash';

/**
 * Ui
 */
import { Types as UiTypes } from '../ducks/ui';
import { growl } from './ui';

export default function* rootSaga() {
  yield all([
    /**
     * Auth
     */
    takeLatest(AuthTypes.LOGIN_REQUEST, login),
    takeLatest(AuthTypes.FORGOT_PASS_SEND_EMAIL, forgotPasswordSendEmail),
    takeLatest(AuthTypes.FORGOT_PASS_CHECK_TOKEN, forgotPasswordCheckToken),
    takeLatest(AuthTypes.FORGOT_PASS_UPDATE_PASS, forgotPasswordUpdatePassword),
    takeLatest(AuthTypes.UPDATE_USER_REQUEST, updateTriiderUser),
    takeLatest(AuthTypes.GET_COMPANIES_BY_USER_REQUEST, getCompanies),
    takeLatest(AuthTypes.CHANGE_COMPANY_USER, changeCompanyUser),

    /**
     * Ui
     */
    takeEvery(UiTypes.GROWL_ADDED, growl),

    /**
     * Local
     */
    takeLatest(LocalsTypes.INCLUDE_LOCAL_REQUEST, includeLocal),
    takeLatest(LocalsTypes.EDIT_LOCAL_REQUEST, editLocal),
    takeLatest(LocalsTypes.DELETE_LOCAL_REQUEST, deleteLocal),
    takeLatest(LocalsTypes.GET_LOCALS_REQUEST, getLocals),

    /**
     * Service Form
     */
    takeLatest(FormTypes.FINISH_FORM_REQUEST, finishForm),

    /**
     * Company Responsibility
     */
    takeLatest(CompanyRespTypes.GET_RESPONSIBILITY_REQUEST, getResponsibilities),
    takeLatest(CompanyRespTypes.SET_RESPONSIBILITY_REQUEST, setResponsibilities),

    /**
     * Task
     */
    takeLatest(TaskTypes.GET_TABS_STATUS_REQUEST, getTabsStatus),
    takeLatest(TaskTypes.SET_STATUS_FILTER, getTaskByStatus),
    takeLatest(TaskTypes.GET_TASKS_REQUEST, getTasks),
    takeEvery(TaskTypes.SETUP_TASKS_FILTERS, getTasksFilters),
    takeLatest(TaskTypes.GET_TASKS_FILTERS_REQUEST, getTasksFilters),
    takeLatest(TaskTypes.GET_TASK_DETAIL_REQUEST, getTaskDetail),
    takeLatest(TaskTypes.HIRE_TASK_REQUEST, hireTask),
    takeLatest(TaskTypes.GET_CANCEL_TASK_OPTIONS_REQUEST, getCancelTaskOptions),
    takeLatest(TaskTypes.CANCEL_QUOTE_TASK_REQUEST, cancelQuoteTask),
    takeLatest(TaskTypes.CANCEL_HIRED_TASK_REQUEST, cancelHiredTask),
    takeLatest(TaskTypes.RATING_TASK_PROFESSIONAL_REQUEST, ratingTaskProfessionalRequest),
    takeLatest(TaskTypes.AUTHORIZE_TASK_REQUEST, authorizeTaskRequest),
    takeLatest(TaskTypes.SCHEDULING_TASK_REQUEST, scheduling),
    takeLatest(TaskTypes.REPORT_PROBLEM_REASONS_REQUEST, getReportProblemReasons),
    takeLatest(TaskTypes.REPORT_PROBLEM_REQUEST, reportProblem),
    takeLatest(TaskTypes.GET_REPORT_PROBLEMS_REQUEST, getReportProblems),
    takeLatest(TaskTypes.ADD_PHOTOS_TO_TASK_REQUEST, addPhotosToTask),
    takeLatest(TaskTypes.REMOVE_PHOTO_FROM_TASK_REQUEST, removePhotosFromTask),
    takeLatest(TaskTypes.TASK_PAYMENT_INFO_REQUEST, paymentInfo),
    takeLatest(TaskTypes.SET_TASK_IS_NEEDED_VISIT_REQUEST, setTaskIsNeedVisit),
    takeLatest(TaskTypes.EDIT_TASK_VISIT_REQUEST, setTaskVisit),
    takeLatest(TaskTypes.GET_COMMENTS_REQUEST, getComments),
    takeLatest(TaskTypes.INCLUDE_COMMENTS_REQUEST, includeComment),
    takeLatest(TaskTypes.INCLUDE_LABELS_TASK_REQUEST, includeLabelTask),
    takeLatest(TaskTypes.REMOVE_LABELS_TASK_REQUEST, deleteLabelTask),
    takeLatest(TaskTypes.SET_TASK_OPERATOR_REQUEST, setOperatorTask),
    /**
     * Pro
     */
    takeLeading(ProTypes.GET_PRO_PROFILE_REQUEST, getProProfile),
    takeLeading(ProTypes.GET_PRO_PORTFOLIO_REQUEST, getProPortfolio),

    /**
     * Chat
     */
    takeEvery(ChatTypes.INIT_CHAT_REQUEST, initChat),
    takeEvery(ChatTypes.SEND_MESSAGE, sendMessage),
    takeEvery(ChatTypes.START_TYPING, startTyping),
    takeEvery(ChatTypes.STOP_TYPING, stopTyping),
    takeLeading(ChatTypes.READ_MESSAGES, readMessages),

    /**
     * Dashboard
     */
    takeLeading(DashTypes.GET_DASH_DATA_REQUEST, getDashsInfo),
    takeLeading(DashTypes.GET_INVOICES_DASH_REQUEST, getInvoicesDash),
    takeLeading(DashTypes.GET_PAYMENT_TICKET_DASH_REQUEST, getPaymentTicketsDash),
  ]);
}
